import { render, staticRenderFns } from "./StickyToolbar.vue?vue&type=template&id=0624413a"
import script from "./StickyToolbar.vue?vue&type=script&lang=js"
export * from "./StickyToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0624413a')) {
      api.createRecord('0624413a', component.options)
    } else {
      api.reload('0624413a', component.options)
    }
    module.hot.accept("./StickyToolbar.vue?vue&type=template&id=0624413a", function () {
      api.rerender('0624413a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/StickyToolbar.vue"
export default component.exports